module.exports = __webpack_public_path__ + "img/bj53.decb99dc.png";